import { z } from "zod";

export const mcpRequestUploadBodySchema = z.object({
    workspaceId: z.string().uuid(),
    fileName: z.string().trim().min(1).max(255),
    entityId: z.coerce
        .number()
        .int()
        .positive()
        .optional()
        .describe(
            "Optional numeric Kick entity id in this workspace. Persist it on the document so migration-file auto-match can attach the upload. Omit for workspace-only receipts.",
        ),
});

export const mcpConfirmUploadBodySchema = z.object({
    uploadToken: z.string().min(1),
});

export const mcpDownloadDocumentBodySchema = z.object({
    documentId: z.number().int().positive(),
});
